/**
 * Custom hook to validate and set Regtank onboarding URL
 * Eliminates duplication of Regtank validation logic
 */

import { useCallback } from "react";
import {
  checkOnboardingLinkValid,
  getLatestRegtankOnboardingDetail,
} from "@funded-here-interface/common/src/Utils/regtankOnboardingHelper";
import { UserDetail } from "./useUserDataSync";

interface UseRegtankValidationReturn {
  validateAndSetRegtankUrl: (
    userDetail: UserDetail,
    setRegtankUrl: (url: string) => void
  ) => {
    isValid: boolean;
    detail: any;
  };
}

/**
 * Hook to validate Regtank onboarding link and set URL if valid
 * @returns Function to validate and set Regtank URL
 */
export const useRegtankValidation = (): UseRegtankValidationReturn => {
  const validateAndSetRegtankUrl = useCallback(
    (userDetail: UserDetail, setRegtankUrl: (url: string) => void) => {
      const regtankRequestDetail = getLatestRegtankOnboardingDetail(
        userDetail?.regtankRequest
      );

      const isValidOnboardinglink = regtankRequestDetail
        ? checkOnboardingLinkValid(
            regtankRequestDetail.noOfAttemptLiveness,
            regtankRequestDetail.onboardingStatus,
            regtankRequestDetail.expiredDate
          )
        : false;

      if (isValidOnboardinglink && regtankRequestDetail) {
        setRegtankUrl(regtankRequestDetail.verifyLink);
      }

      return {
        isValid: isValidOnboardinglink,
        detail: regtankRequestDetail,
      };
    },
    []
  );

  return { validateAndSetRegtankUrl };
};
